module.exports = __webpack_public_path__ + "img/orbia.8aaae17b.svg";